'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/Slider/Slider.tsx
import * as SliderPrimitive from "@radix-ui/react-slider";
import { twMerge } from "tailwind-merge";
import { ChevronIcon } from "@wbk/svg";
import { jsx, jsxs } from "react/jsx-runtime";
var RANGE_THEME_CLASSES = {
  primary: "bg-primary",
  secondary: "bg-secondary",
  tertiary: "bg-tertiary",
  action: "bg-action",
  error: "bg-error",
  success: "bg-success",
  white: "bg-dark",
  black: "bg-light",
  transparent: "bg-transparent"
};
var THUMB_THEME_CLASSES = {
  primary: "border-primary focus:ring-primary bg-primary text-primary-contrast",
  secondary: "border-secondary focus:ring-secondary bg-secondary text-secondary-contrast",
  tertiary: "border-tertiary focus:ring-tertiary bg-tertiary text-tertiary-contrast",
  action: "border-action focus:ring-action bg-action text-action-contrast",
  error: "border-error focus:ring-error bg-error text-error-contrast",
  success: "border-success focus:ring-success bg-success text-success-contrast",
  white: "border-dark focus:ring-dark bg-white text-black",
  black: "border-light focus:ring-light bg-black text-white",
  transparent: "border-transparent focus:ring-transparent bg-transparent text-text"
};
var Slider = (_a) => {
  var _b = _a, { className, theme = "primary", thumb = "default" } = _b, props = __objRest(_b, ["className", "theme", "thumb"]);
  const value = props.value || props.defaultValue;
  return /* @__PURE__ */ jsxs(
    SliderPrimitive.Root,
    __spreadProps(__spreadValues({
      className: twMerge(
        "bg-primary-contrast relative flex w-full touch-none select-none items-center",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx(SliderPrimitive.Track, { className: "bg-body-level-1 relative h-[3px] w-full grow overflow-hidden rounded-full", children: /* @__PURE__ */ jsx(SliderPrimitive.Range, { className: twMerge("absolute h-full", RANGE_THEME_CLASSES[theme]) }) }),
        value == null ? void 0 : value.map((_, i) => {
          const isFirst = i === 0;
          const isLast = i === value.length - 1;
          return /* @__PURE__ */ jsx(
            SliderPrimitive.Thumb,
            {
              className: twMerge(
                "bg-body ring-offset-body flex h-7 w-7 items-center justify-center rounded-full border-2 focus:ring-1 focus:ring-offset-1 disabled:pointer-events-none",
                THUMB_THEME_CLASSES[theme]
              ),
              children: thumb === "chevron" && /* @__PURE__ */ jsx(
                ChevronIcon,
                {
                  className: twMerge(
                    "h-2.5 w-2.5 shrink-0",
                    isFirst && value.length > 1 && "ltr:rotate-180",
                    isLast && value.length > 1 && "rtl:rotate-180"
                  )
                }
              )
            },
            i
          );
        })
      ]
    })
  );
};
var Slider_default = Slider;

export {
  Slider_default
};
//# sourceMappingURL=chunk-HCYSL3OM.mjs.map